import axios from 'axios';
import {EventClient} from "../util/eventClient";
import {getGlobalState} from "../constants/GlobalStore";

// const API_URL = "https://amskills-portal-smithos.c9users.io:8081/s1/";
const API_URL = "/s1/";
let tHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};
module.exports = {
  postData(url = '', data = {}) {
    let token = getGlobalState('token') || "";
    if (token.length > 0) tHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      url: url,
      method: 'post',
      headers: tHeaders,
      responseType: 'json',
      data: data,
    }).then(response => response.data).catch(reason => {
      console.log(reason);
      EventClient.emit("GLOBAL_ERROR", reason);
      return false;
    });
  },
  putData(url = '', data = {}) {
    let token = getGlobalState('token') || "";
    if (token.length > 0) tHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      url: url,
      method: 'put',
      headers: tHeaders,
      responseType: 'json',
      data: data,
    }).then(response => response.data).catch(reason => {
      console.log(reason);
      EventClient.emit("GLOBAL_ERROR", reason);
      return false;
    });
  },
  patchData(url = '', data = {}) {
    let token = getGlobalState('token') || "";
    if (token.length > 0) tHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      url: url,
      method: 'patch',
      headers: tHeaders,
      responseType: 'json',
      data: data,
    }).then(response => response.data).catch(reason => {
      console.log(reason);
      EventClient.emit("GLOBAL_ERROR", reason);
      return false;
    });
  },
  getData(url = "", data = {}) {
    let token = getGlobalState('token') || "";
    if (token.length > 0) tHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      params: data,
      url: url,
      method: 'get',
      headers: tHeaders,
      responseType: 'json',
    }).then(response => response.data).catch(reason => {
      console.log(reason);
      EventClient.emit("GLOBAL_ERROR", reason);
      return false;
    });
  },
  deleteData(url = '', data = {}) {
    let token = getGlobalState('token') || "";
    if (token.length > 0) tHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      url: url,
      method: 'delete',
      headers: tHeaders,
      responseType: 'json',
      data: data,
    }).then(response => response.data).catch(reason => {
      console.log(reason);
      EventClient.emit("GLOBAL_ERROR", reason);
      return false;
    });
  },

  uploadFile(url = "", data) {
    var lHeaders = {
      'Content-Type': 'multipart/form-data',
    };
    let token = getGlobalState('token') || "";
    if (token.length > 0) lHeaders['token'] = token;
    return axios({
      baseURL: API_URL,
      url: url,
      method: "POST",
      cache: false,
      headers: lHeaders,
      responseType: 'json',
      data: data,
    }).then(response => response.data);
  }
};



// WEBPACK FOOTER //
// ./src/api/doLogin.js